import { createSlice } from '@reduxjs/toolkit';

const MerchantInfoSlice = createSlice({
  name: 'MerchantInfoSlice',
  initialState: {
    isLoading: false,
    merchantInfoData: [],
    isError: null,
  },
  reducers: {
    /////// Merchant Info List //////
    requestMerchantInfo: (state) => {
      return { ...state, isLoading: true };
    },
    responseMerchantInfo: (state, action) => {
      return {
        ...state,
        isLoading: false,
        merchantInfoData: action?.payload?.data,
      };
    },
    failureMerchantInfo: (state, action) => {
      return {
        ...state,
        isLoading: false,
        isError: action?.payload,
      };
    },
  },
});

export const {
  requestMerchantInfo,
  responseMerchantInfo,
  failureMerchantInfo,
} = MerchantInfoSlice.actions;

export default MerchantInfoSlice.reducer;
